module.exports = __webpack_public_path__ + "img/ic-lexique.6fa5a406.svg";